module.exports = __webpack_public_path__ + "img/w3_circle_close_white.3a8f6bc9.png";